import {useTranslation} from "next-i18next";
import MetaData from "../../../components/metadata";
import React from "react";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import Link from "next/link";

export default function Index() {
    // init
    const { t } = useTranslation();

    // render
    return (
        <>
            {/* Metadata */}
            <MetaData
                type={'website'}
                title={t('add.product')}
                description={t('add.product.lead', { ns: 'glossary' })}
                keywords={[t('add.product')]}
                imageURL={process.env.logoURL}
            />

            {/* Header */}
            <Header />

            {/* Image */}
            <svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" fill="currentColor"
                 className="bi bi-bag-plus d-block m-auto mt-5 text-primary" viewBox="0 0 16 16">
                <path fillRule="evenodd"
                      d="M8 7.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0v-1.5H6a.5.5 0 0 1 0-1h1.5V8a.5.5 0 0 1 .5-.5z"/>
                <path
                    d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/>
            </svg>

            {/* Header */}
            <h1 className="text-center fw-bold ms-3 me-3 ms-lg-4 me-lg-4 ps-lg-5 pe-lg-5 mt-5">{t('add.product')}</h1>

            {/* Lead */}
            <p className={'lead text-center ms-3 me-3 ms-lg-4 me-lg-4 ps-lg-5 pe-lg-5'}>{t('add.product.lead', { ns: 'glossary' })}</p>

            {/* Choice */}
            <div className={'row mt-3 mt-lg-5 ms-3 me-3 ms-md-4 me-md-4 ps-lg-5 pe-lg-5 mb-5 pb-3'}>
                {/* By camera */}
                <div className={'col-6 container mt-4 mt-lg-0 text-decoration-none'}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor"
                         className="bi bi-camera d-block m-auto" viewBox="0 0 16 16">
                        <path
                            d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"/>
                        <path
                            d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
                    </svg>
                    <h2 className={'h6 text-center'}>
                        <Link href={'/product/add/camera'} className={'btn btn-primary text-decoration-none'} role={'button'}>
                            {t('take.pictures')}
                        </Link>
                    </h2>
                    <p className={'text-center'}>{t('add.products.by.pictures', { ns: 'glossary' })}</p>
                </div>

                {/* By keyboard */}
                <div className={'col-6 container mt-4 mt-lg-0'}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor"
                         className="bi bi-keyboard d-block m-auto" viewBox="0 0 16 16">
                        <path
                            d="M14 5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12zM2 4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2z"/>
                        <path
                            d="M13 10.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm0-2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-5 0A.25.25 0 0 1 8.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 8 8.75v-.5zm2 0a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-.5zm1 2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-5-2A.25.25 0 0 1 6.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 6 8.75v-.5zm-2 0A.25.25 0 0 1 4.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 4 8.75v-.5zm-2 0A.25.25 0 0 1 2.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 2 8.75v-.5zm11-2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-2 0A.25.25 0 0 1 9.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 9 6.75v-.5zm-2 0A.25.25 0 0 1 7.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 7 6.75v-.5zm-2 0A.25.25 0 0 1 5.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 5 6.75v-.5zm-3 0A.25.25 0 0 1 2.25 6h1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-1.5A.25.25 0 0 1 2 6.75v-.5zm0 4a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm2 0a.25.25 0 0 1 .25-.25h5.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-5.5a.25.25 0 0 1-.25-.25v-.5z"/>
                    </svg>
                    <h2 className={'h6 text-center'}>
                        <Link href={'/product/add/keyboard'} className={'btn btn-primary text-decoration-none'} role={'button'}>
                            {t('use.keyboard')}
                        </Link>
                    </h2>
                    <p className={'text-center'}>{t('add.products.by.keyboard', { ns: 'glossary' })}</p>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </>
    );
}

/**
 *
 * @param context
 * @returns {Promise<{props: {}}>}
 */
export async function getStaticProps(context) {
    return {
        props: {
            ...(await serverSideTranslations(context.locale, ['common', 'languages', 'countries', 'glossary', 'units'])),
        }
    };
}